import { sentenceCase } from "change-case-all";
import { Grid, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";

import { Mandatory } from "../FormOne";
import { TextField } from "../../../../components";
import { colors } from "../../../css components/Style";

function Range({ state, dispatch, field, editState, formikProps }) {
  const [input, setInput] = useState({});
  const [message, setMessage] = useState({});

  function handleMandate(name) {
    let value = false;
    let key = "mandatory";
    if (
      input?.[field.name]?.value?.[field.options[0].value] &&
      input[field.name]?.value?.[field.options[1].value]
    ) {
      dispatch({
        type: "CALCULATE_PERCENTAGE",
        payload: { value, name, key },
      });
    }
  }

  const handleFieldChange = (value, name, key) => {
    if (
      !input?.[field.name]?.value?.[field.options[0].value] &&
      !input[field.name]?.value?.[field.options[1].value]
    ) {
      let noRange = "empty";
      dispatch({
        type: "RANGE_UPDATE",
        payload: { value, name, key, noRange },
      });
      handleMandate(name);
    } else {
      dispatch({ type: "RANGE_UPDATE", payload: { value, name, key } });
    }
  };

  useEffect(() => {
    if (state[field.name]) {
      setInput((prev) => ({
        ...prev,
        [field.name]: state[field.name],
      }));
    }
  }, [state, field.name]);

  function handleValueValidation(num1, num2 = 0, field, value, key) {
    if (
      parseInt(num1) > parseInt(num2) ||
      parseInt(value) < field.min_default_val ||
      parseInt(value) > field.max_default_val
    ) {
      setMessage({
        ...message,
        [field.name]: {
          ...message[field.name],
          [key]: sentenceCase(
            field.label +
              " should be less than " +
              field.max_default_val +
              " & greater than " +
              field.min_default_val +
              " and min " +
              field.label +
              " should be greater than max " +
              field.label
          ),
        },
      });
    } else {
      let messages = { ...message };
      for (let message in messages) {
        delete messages?.[message];
      }
      setMessage(messages);
    }
  }
  return (
    <Fragment>
      <Grid size={6}>
        <Grid container spacing={0}>
          <Grid size={12} style={{ paddingTop: "0px" }}>
            <Mandatory
              dispatch={dispatch}
              state={state}
              editState={editState}
              field={field}
              formikProps={formikProps}
            />
          </Grid>

          <div style={{ display: "flex", width: "100%", gap: "10px" }}>
            <Grid size={6}>
              <TextField
                value={input?.[field.name]?.value?.[field.options[0].value]}
                size="small"
                label={field.options[0].label}
                onBlur={(e) => {
                  handleFieldChange(
                    input[field.name]?.value?.[field.options[0].value],
                    field.name,
                    `${field.options[0].value}`
                  );
                }}
                onChange={(e) => {
                  const { value } = e.target;
                  if (isNaN(value)) {
                    setMessage({
                      ...message,
                      [field.name]: {
                        ...message[field.name],
                        [field.options[0].value]: "Please enter a digit",
                      },
                    });
                    return;
                  }

                  handleValueValidation(
                    value,
                    input?.[field.name]?.value?.[field.options[1].value],
                    field,
                    value,
                    field.options[0].value
                  );

                  setInput((prev) => ({
                    ...prev,
                    [field.name]: {
                      value: {
                        ...input[field.name]?.value,
                        [field.options[0].value]: value,
                      },
                    },
                  }));
                }}
                name={`${field.name}.value.${field.options[0].value}`}
                placeholder={field.options[0].label}
                disabled={!editState}
              />

              <Typography color={colors.error} variant="caption">
                {message[field.name]?.[field.options[0].value]}
              </Typography>
            </Grid>

            <Grid size={6}>
              <TextField
                size="small"
                label={field.options[1].label}
                onBlur={(e) => {
                  handleFieldChange(
                    input[field.name]?.value?.[field.options[1].value],
                    field.name,
                    `${field.options[1].value}`
                  );
                }}
                onChange={(e) => {
                  const { value } = e.target;

                  handleValueValidation(
                    input?.[field.name]?.value?.[field.options[0].value],
                    value,
                    field,
                    value,
                    field.options[1].value
                  );

                  setInput((prev) => ({
                    ...prev,
                    [field.name]: {
                      value: {
                        ...input[field.name]?.value,
                        [field.options[1].value]: e.target.value,
                      },
                    },
                  }));
                }}
                value={input?.[field.name]?.value?.[field.options[1].value]}
                name={`${field.name}.value.${field.options[1].value}`}
                placeholder={field.options[1].label}
                disabled={!editState}
              />

              <Grid size={12}>
                <Typography color={colors.error} variant="caption">
                  {message[field.name]?.[field.options[1].value]}
                </Typography>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Range;
